export default class AssertError extends Error {
  constructor(message) {
    super(message);

    this.name = 'AssertError';
  }
}
